import client from './client';

export default async (): Promise<string[]> => {
    const media = await client.getAssets();

    return media.items.map((item) => {
        return item.fields.file.url;
    });
};
